import React from "react";
import "../../styles/pages/_home.css";
import growthImg from "../../assets/images/growth.png";

export default function GrowthSection() {
  return (
    <section className="growth-section">
      {/* Heading */}
      <div className="growth-heading">
        <h2>Empowering Growth, Together</h2>
      </div>

      {/* 2-Column Layout */}
      <div className="growth-row">
        {/* Left - Image */}
        <div className="growth-col growth-image">
          <img src={growthImg} alt="Growth" />
        </div>

        {/* Right - Content */}
        <div className="growth-col growth-content">
          <div className="growth-content-inner">
          <p className="growth-intro">
            Bizverto partners with you to design and implement agile strategies across HR, IT, and business operations, ensuring seamless integration of people, processes, and technology — driving efficiency, fostering innovation, and delivering measurable, long-term impact for your organization.
          </p>

          <div className="growth-points">
            <div className="growth-point">
              <div className="point-icon">👥</div>
              <div>
                <h3>People-First Ecosystems</h3>
                <p>Aligning talent with purpose for resilient organizations.</p>
              </div>
            </div>

            <div className="growth-point">
              <div className="point-icon">⚡</div>
              <div>
                <h3>Agile Transformation</h3>
                <p>Helping businesses adapt faster to changing environments.</p>
              </div>
            </div>

            <div className="growth-point">
              <div className="point-icon">📈</div>
              <div>
                <h3>Scalable Solutions</h3>
                <p>Building frameworks that evolve as you grow.</p>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </section>
  );
}
